import { translate } from '../../../../utils/locale';
import { getFutureContractsAPI } from '../../../../api/subscriptionAPI';
import { getClientId } from 'features/app/redux/context';
import { updateErrorMessage, updateFutureContracts } from '../slice';

/**
 * Get the future contracted agreements from the API and store them in Redux.
 */
export const getFutureContractsThunk = (): AppThunk => async (dispatch, getState) => {
	const clientId = getClientId(getState());

	if (!clientId) {
		dispatch(updateFutureContracts([]));
		return;
	}

	try {
		const futureContracts = await getFutureContractsAPI();

		if (futureContracts.HasError) {
			dispatch(
				updateErrorMessage(
					translate('manageAccount.subscriptions.errors.FAILED_TO_FETCH_DATA') as string
				)
			);
			dispatch(updateFutureContracts([]));
		} else {
			dispatch(updateFutureContracts(futureContracts.ResponseObject));
		}
	} catch {
		dispatch(
			updateErrorMessage(
				translate('manageAccount.subscriptions.errors.FAILED_TO_FETCH_DATA') as string
			)
		);
		dispatch(updateFutureContracts([]));
	}
};
